// extracted by mini-css-extract-plugin
export default {"list_menu":"index_list_menu_6k55F","morehNew":"index_morehNew_9uUYA","more":"index_more_ZhpUP"};